import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  appVersion: () => faker.internet.mac(),
  batteryLevel: 100,
  bluetoothStatus: 'UNKNOWN',
  chargingStatus: 'CHARGING',
  clientId: () => faker.internet.mac(),
  displayName: () => faker.internet.mac(),
  jackStatus: 'UNKNOWN',
  ledAudioType: 'VISUAL_TARGET',
  lightbarDetected: false,
  model: () => faker.commerce.productName(),
  name: () => faker.commerce.productName(),
  offlineAt: null,
  osVersion: () => faker.commerce.department(),
  status: () => faker.color.human(),
  volume: () => faker.number.int(5),

  withRoom: trait({
    afterCreate(device, server) {
      server.create('roomba/room', { devices: [device] });
    },
  }),
});
